import Vue from 'vue'
import * as R from 'ramda'
import * as moment from 'moment'
import '@babel/polyfill'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { setContext } from 'apollo-link-context'
import VueApollo from 'vue-apollo'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import BaiduMap from 'vue-baidu-map'

import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(BaiduMap, {
  ak: process.env.VUE_APP_BMAP_AK
})

Vue.config.productionTip = false

Vue.prototype.$R = R

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_KEY as string)
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  }
})

const link = new HttpLink({
  uri: process.env.VUE_APP_API_URL
})
const apolloClient = new ApolloClient({
  link: authLink.concat(link),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore'
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all'
    }
  },
  connectToDevTools: true
})
const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

declare module 'vue/types/vue' {
  interface Vue {
    $R: any;
    $moment: any;
  }
}

Object.defineProperties(Vue.prototype, {
  $R: {
    get () {
      return R
    }
  },
  $moment: {
    get () {
      return moment
    }
  }
})

Vue.use(VueApollo)
Vue.use(mavonEditor)

new Vue({
  store,
  vuetify,
  apolloProvider,
  router,
  render: h => h(App)
}).$mount('#app')
